/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from "moment";
import LogoConectaBranca from "../../../assets/images/logo-conectadoc-branca.png";
import { usePartnerData } from "../../../providers/partnerData";

const Footer = () => {
  const { partnerData } = usePartnerData();

  return (
    <footer id="footer" className="text-white">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-sm-6 col-lg-4 text-center text-sm-start order-0">
            <a id="hlLogoFooter" href={partnerData?.url}>
              <img
                id="ImgFooter"
                className="responsive"
                src={partnerData?.imgFooter}
                style={{ height: "40px" }}
              />
            </a>
          </div>
          <div className="col-12 col-lg-4 text-center order-2 order-lg-1 pt-3 pt-lg-0">
            <p className="mb-0">
              Todos os direitos reservados © {moment().format("YYYY")}{" "}
              Conectadoc.
            </p>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 text-center text-sm-end order-1 order-lg-2 pt-3 pt-sm-0">
            <p className="mb-0">
              Tecnologia:
              <a href="https://conectadoc.com.br/">
                <img
                  src={LogoConectaBranca}
                  width="100"
                  className="img-fluid v-align-m"
                />
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
